import { useEffect, useCallback, useState } from 'react'
import { Typography, App, Flex, Input, QRCode } from 'antd'
import { ReloadOutlined, CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons'
import useAuthStore from '@/stores/AuthStore'
import { fetchQRCode } from '@/actions/WaiAction'
import useConversationStore from '@/stores/ConversationStore'
import { isEmpty } from '@/utils/commons'

// 把 QR Code 转换成二维码，用来本地测试 WhatsApp Baileys 框架
const LocalWhatsAppQRCode = () => {

  const [qrCode, setQRCode] = useState('expired')

  return (
    <Flex justify='center' align='center' gap='middle' vertical>
      <Typography.Title level={4}>WhatsApp Baileys</Typography.Title>
      <QRCode size={264} value={qrCode} errorLevel='L' />
      <Input style={{ width: 400, marginTop: 16 }} placeholder='QR Code' onChange={(e) => {
        setQRCode(e.target.value)
      }}/>
    </Flex>
  )
}
export default LocalWhatsAppQRCode
